import { z } from 'zod';

import { errorMessage } from '../config';

export type RegisterSchema = z.infer<typeof registerData>;
export type RegisterErrors = z.inferFlattenedErrors<
	typeof registerData
>['fieldErrors'];

export type RegisterConfirmSchema = z.infer<typeof registerConfirmData>;
export type RegisterConfirmErrors = z.inferFlattenedErrors<
	typeof registerConfirmData
>['fieldErrors'];

const registerCodeData = z.object({
	email: z.string().email(errorMessage.email_invalid),
});

export const registerData = registerCodeData.extend({
	promoCode: z.string().optional(),
	confirmPolicy: z.boolean({ coerce: true }).refine((arg) => !!arg),
	confirmOffert: z.boolean({ coerce: true }).refine((arg) => !!arg),
});

export const registerConfirmData = registerCodeData
	.extend({
		advertisingMail: z.boolean({ coerce: true }),
		login: z
			.string()
			.min(3, errorMessage.login_too_short)
			.refine(
				(arg) => !/[^a-zA-Z0-9._-]/.test(arg),
				errorMessage.login_invalid,
			),
		password: z
			.string()
			.min(8, errorMessage.password_too_short)
			.refine(
				(arg) => !/[^a-zA-Z0-9!@#$%^&*+_=-]/.test(arg),
				errorMessage.password_invalid,
			),
		confirmPassword: z.string(),
		emailCode: z.string().length(6, errorMessage.otp_not_matched),
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: errorMessage.password_not_match,
		path: ['confirmPassword'],
	});
